import { render, staticRenderFns } from "./NewClassView.vue?vue&type=template&id=6afabff0"
import script from "./NewClassView.vue?vue&type=script&lang=js"
export * from "./NewClassView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports